import { render, staticRenderFns } from "./VendorView.vue?vue&type=template&id=919deaac"
import script from "./VendorView.vue?vue&type=script&lang=js"
export * from "./VendorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('919deaac')) {
      api.createRecord('919deaac', component.options)
    } else {
      api.reload('919deaac', component.options)
    }
    module.hot.accept("./VendorView.vue?vue&type=template&id=919deaac", function () {
      api.rerender('919deaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vendor/VendorView.vue"
export default component.exports